module.exports = __webpack_public_path__ + "static/35-49366fc15d5ee714333853c822bc515b.png";